import axios from "axios";
import { apiEndpoint } from "../config";
import refreshInterceptor from "./refreshInterceptor/refreshInterceptor";

const NotificationAPI = axios.create({
  baseURL: apiEndpoint.baseUrl,
  headers: {
    "content-type": "application/json",
  },
});
NotificationAPI.interceptors.request.use(refreshInterceptor);

export default NotificationAPI;
